
import Vue from 'vue'
/**
 * 加载插件设置
 */
import ViewDesign from './plugins/view-design'
import cookie from './plugins/js-cookie'
import request from './plugins/request'

ViewDesign(Vue);


/**
 * 加载项目内部设置
 */
const appearance = {
    theme: 'dark',
    color_dark: '#fff',         // 深色模式下 图标颜色
    color_light: '#495060'      // 浅色模式下 图标颜色
}
const client = {
    title: 'Capricorn.Admin',
    mini_title: "CA"
}
const errors = [{
    code: 401,
    msg: '未经过授权'
}, {
    code: 403,
    msg: '禁止访问'
}, {
    code: 404,
    msg: '找不到页面了'
}, {
    code: 500,
    msg: '服务器错误'
}]






const config = {
    ...client,
    errors,
    ...appearance
}

Plugin.install = function(Vue, options) {
    Vue.option = config;
    window.option = config;

    Vue.cookie = cookie;
    window.cookie = cookie;


    Vue.request = request;
    window.request = request;

    Object.defineProperties(Vue.prototype, [
        {
            option: {get:()=> config},
            $option: {get:() =>config},
        },
        {
            cookie:{get:()=>cookie},
            $cookie:{get:()=>cookie},
        },
        {
            request:{get:()=>request},
            $request:{get:()=>request},
        },
    ]);
};

Vue.use(Plugin)

export default Plugin;





